<template>
  <transition name="product">
    <div class="scan-detail">
      <van-nav-bar
        @click-left="onClickLeft"
        :title="title"
        left-text="返回"
        left-arrow
      >
      </van-nav-bar>

      <component
        v-if="compshow"
        v-bind:is="currentTabComponent.components"
        :data="data"
        :companyId="companyId"
      ></component>
    </div>
  </transition>
</template>

<script>
const tabs = {
  shiXinCheck: { title: "失信核查", components: "shiXinCheck" },  // 
  zhiXingCheck: { title: "被执行核查", components: "zhiXingCheck" }, //
  courtAnnoCheck: { title: "开庭公告", components: "courtAnnoCheck" }, // 
  judgmentDocCheck: { title: "裁判文书", components: "judgmentDocCheck" },
  judicialSaleCheck: { title: "司法拍卖", components: "judicialSaleCheck" }, //
  opChangePromptCheck: { title: "法人变更", components: "opChangePromptCheck" }, //
  parChangePromptCheck: { title: "大股东变更", components: "parChangePromptCheck" }, //
  equityPledgedCheck: { title: "股权出质", components: "equityPledgedCheck" }, // 
  chattelMortgageCheck: { title: "动产抵押", components: "chattelMortgageCheck"}, //
  equityFreezeCheck: { title: "股权冻结", components: "equityFreezeCheck" }, // 
  adminPenaltyCheck: { title: "行政处罚", components: "adminPenaltyCheck" }, //
  landMortgageCheck: { title: "土地抵押", components: "landMortgageCheck" }, // 
  envPunishmentCheck: { title: "环保处罚", components: "envPunishmentCheck" }, //
  taxIllegalCheck: { title: "税收违法", components: "taxIllegalCheck" }, //
};

import shiXinCheck from "./components/shiXinCheck";
import courtAnnoCheck from "./components/courtAnnoCheck";
import zhiXingCheck from "./components/zhiXingCheck";
import judgmentDocCheck from "./components/judgmentDocCheck";
import judicialSaleCheck from "./components/judicialSaleCheck";
import opChangePromptCheck from "./components/opChangePromptCheck";
import parChangePromptCheck from "./components/parChangePromptCheck";
import equityPledgedCheck from "./components/equityPledgedCheck";
import chattelMortgageCheck from "./components/chattelMortgageCheck";
import equityFreezeCheck from "./components/equityFreezeCheck";
import adminPenaltyCheck from "./components/adminPenaltyCheck";
import landMortgageCheck from "./components/landMortgageCheck";
import envPunishmentCheck from "./components/envPunishmentCheck";
import taxIllegalCheck from "./components/taxIllegalCheck";

export default {
  components: {
    shiXinCheck,
    zhiXingCheck,
    courtAnnoCheck,
    judgmentDocCheck,
    judicialSaleCheck,
    opChangePromptCheck,
    parChangePromptCheck,
    equityPledgedCheck,
    chattelMortgageCheck,
    equityFreezeCheck,
    adminPenaltyCheck,
    landMortgageCheck,
    envPunishmentCheck,
    taxIllegalCheck,
  },
  data() {
    return {
      compshow: false,
      title: "",
      data: {},
      tabs: {},
      companyId: "",
      currentTabComponent: tabs.shiXinCheck,
    };
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
  },
  created() {
    this.tabs = Object.assign({}, tabs);
    let key = this.$route.query.key;
    let companyId = this.$route.query.companyId;
    let obj = localStorage.getItem("risk_data");
    try{
      obj = JSON.parse(obj);
      this.data = obj;
      this.compshow = true;
    }catch(e){}
    this.companyId = companyId;
    this.title = this.tabs[key].title;
    this.currentTabComponent = this.tabs[key];
  },
};
</script>

<style lang="scss" scoped>
.scan-detail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
</style>